/**
 * Pops specified content from event
 * @param  {Object} event - description of event from store
 * @return {Object|Undefined} - found content description in the event
 */
export default function getEventContent(contentType, event) {
  return event.content.find((item) => item.contentType === contentType);
}
